// JavaScript source code
import './styles/StudiosPage.css';
import GameImageHeader from './GameImageHeader';
import { useState, useRef, useEffect } from 'react';
import Cookies from 'js-cookie';
import webContentStrings from "./ContentStrings/LocalizedStrings.js";
import { IsMobile } from './Utilities.js';

function StudiosPage() {
    const devName = useRef();
    const devEmail = useRef();
    const [caseStudyIndex, setCaseStudyIndex] = useState(0);
    const caseStudyData = [{ 'name': "Session Information", 'image': "/LudareAnalyticsSessions.png", 'text': "Find out who, how often, and how long players are playing your game." },
        { 'name': "Progression Tracking", 'image': "/Heatmaps.png", 'text': "Find out how far players get into your game and where they are falling off." },
        { 'name': "Player Sentiment", 'image': "/SteamReviewChart.png", 'text': "Predict the virality and review scores of your game without risking your Steam reviews." }];
    const [mobile, setMobile] = useState(IsMobile());

    useEffect(() => {
        const handleResize = () => {
            setMobile(IsMobile());
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    function ResourcesSubmit(event) {
        event.preventDefault();

        console.log("submit");

        const signUpReqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'developerName': devName.current, 'email': devEmail.current })
        };

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/ResourcesSignUp', signUpReqOptions)
            .then((res) => res.json())
            .then((data) => {
                console.log(data);
                if (data.success === true) {
                    Cookies.set("ResourcesSignUp", true);
                    window.location.assign("/StudioTools");
                }
            });
    }

    function onValueChange(event) {
        setCaseStudyIndex(parseInt(event.target.value));
    }

    return (
        <div className="studioPage">
            <div className="studioTestimonials">
                <h1 className="testimonialsHeader">{webContentStrings.studioInfoStrings.testimonialTitle1}<span style={{ color: "#f9b422" }}>{webContentStrings.studioInfoStrings.testimonialTitle2}</span>{webContentStrings.studioInfoStrings.testimonialTitle3}</h1>
                <p className="testimonialsDesc">{webContentStrings.studioInfoStrings.tetminonialHeaderInfo1}<span style={{ color: "#f9b422" }}>{webContentStrings.studioInfoStrings.tetminonialHeaderInfo2}</span>{webContentStrings.studioInfoStrings.tetminonialHeaderInfo3}</p>
            </div>
            <div className="studioTestimonialObj">
                <div className={"studioTestimonialBox" + (mobile === true ? "Mobile" : "")}>
                    <div className="testimonialInfo">
                        <p className="testimonialStudioPageName">Azure <span style={{ color: "#f9b422" }}>Ravens</span></p>
                        <p className="testimonialText">...it's going to allow us to start getting players in playtesting the game, giving us feedback, generating that initial revenue that'll help us focus more on this.</p>
                        <p className="testimonialAttribution">-Corbin Reeves</p>
                    </div>
                    <img className="testimonialPicture" src="/AzureRavens.png" />
                </div>
            </div>
            <div className="caseStudies">
                <h1 className="caseStudiesHeader">{webContentStrings.studioInfoStrings.insightsTitle1}<span style={{ color: "#f9b422" }}>{webContentStrings.studioInfoStrings.insightsTitle2}</span>{webContentStrings.studioInfoStrings.insightsTitle3}</h1>
                <p className="caseStudiesDesc">{webContentStrings.studioInfoStrings.insightsDesc}</p>
                <div className="caseStudiesInfo">
                    {caseStudyData.map((entry) => {
                        return (
                            <div className="caseStudiesEntry">
                                <img className="caseStudyPicture" src={entry.image} />
                                <div className="CaseStudyRevInfo">
                                    <p className="caseStudyGameName">{entry.name}</p>
                                    <p className="caseStudyResults">{entry.text}</p>
                                </div>
                            </div>
                        );
                    }
                    )}
                </div>
            </div>

            <div className="earlyRevenue">
                <div className="earlyRevenueContainer">
                    <h1 className="earlyRevenueHeader">{webContentStrings.studioInfoStrings.revenueTitle1}<span style={{ color: "#f9b422" }}>{webContentStrings.studioInfoStrings.revenueTitle2}</span>{webContentStrings.studioInfoStrings.revenueTitle3}</h1>
                    <p className="earlyRevenueDesc">{webContentStrings.studioInfoStrings.revenueDesc}</p>
                    <div className="earlyRevenueObj">
                        <img className="earlyRevenuePicture" src="/RevenueGraph.png" />
                    </div>
                </div>
            </div>

            <div className="publisherPipeline">
                <h1 className="publisherPipelineHeader">{webContentStrings.studioInfoStrings.dataShareTitle1}<span style={{ color: "#f9b422" }}>{webContentStrings.studioInfoStrings.dataShareTitle2}</span>{webContentStrings.studioInfoStrings.dataShareTitle3}</h1>
                <p className="publisherPipelineDesc">{webContentStrings.studioInfoStrings.dataShareDesc}</p>
            </div>

            <div className="studioInfoContainer">
                <h1 className="studiosSectionHeader"><span style={{ color: "#FFFFFF" }}>{webContentStrings.studioInfoStrings.studioSignUpTitle1}</span>{webContentStrings.studioInfoStrings.studioSignUpTitle2}</h1>
                <p className="studioCallToActionDesc">{webContentStrings.studioInfoStrings.studioSignUpDesc}</p>
                <div className="ludareLogoBreak">
                    <hr />
                    <img src="IconBlackNoBackground.png" />
                    <hr />
                </div>
                <form className="studioResourceAccessForm">
                    <div className={"studioResourcesEntries" + (mobile === true ? "Mobile" : "")}>
                        <div className="studioResourcesName">
                            <label className="studioRsourceSignUpLabel" htmlFor="name">DEVELOPER NAME</label>
                            <input className="stuioResourceSignUpInput" type="text" id="name" onChange={(e) => devName.current = e.target.value} />
                        </div>
                        <div className="studioResourcesEmail">
                            <label className="studioRsourceSignUpLabel" htmlFor="email">EMAIL</label>
                            <input className="stuioResourceSignUpInput" type="email" id="email" onChange={(e) => devEmail.current = e.target.value} />
                        </div>
                    </div>
                    <input className="studioResourceSignUpSubmit" type="submit" onClick={ResourcesSubmit} value="Submit" />
                </form>
            </div>
        </div>
    );
}

//<p className="castStudyDisclosure">Based on historic play data and projected Steam sales revenue.</p>

export default StudiosPage;